/**
 * Cash ActionTypes
 */
export enum Actions {
  UPDATE_CASH_INPUT = "UPDATE_CASH_INPUT",
  SET_CASH_INPUT_DIRTY = "SET_CASH_INPUT_DIRTY",
  SWITCH_CASH_VALIDITY = "SWITCH_CASH_VALIDITY",
  SET_CASH_TOKEN = "SET_CASH_TOKEN",
  DISABLE_CASH_FORM = "DISABLE_CASH_FORM",
  ENABLE_CASH_FORM = "ENABLE_CASH_FORM",
  UPDATE_DOCUMENT_TYPE_NUMBER = "UPDATE_DOCUMENT_TYPE_NUMBER",
  UPDATE_CASH_DESCRIPTION = "UPDATE_CASH_DESCRIPTION",
}



// WEBPACK FOOTER //
// ./src/containers/Cash/store/Actions.ts